<template>
  <div class="ofd-box-pc">
    <!-- 头部导航 -->
    <Header type="pc" ref="newHeader" :addUseDialog="false" @showDialog="showDialog" />
    <!-- 留资弹框 -->
    <UseDialog ref="infoDialog" />
    <!-- 二维码弹框 -->
    <QrCodeDialog ref="qrcodeDialog" />
    <!-- Banner -->
    <Banner
      :isPcFlag="true"
      pcTitle="OFD电子保函解决方案"
      pcDesc="e签宝打造业内前沿方案，提供OFD格式电子保函生成、"
      pcSecondDesc="转换、盖章、合并、验签等全流程服务"
      pcBtntext="了解详情"
      pcBtndesc="立即试用"
      :pcBgImg="pcBgImg"
      @showDialog="showDialog"
      @showQrCodeDialog="showQrCodeDialog"
    />
    <!-- 适用对象 -->
    <ApplicableObjects :list="applicableObjectsList" :isPcFlag="true" />
    <!-- 解决方案 -->
    <Solution :list="solutionList" :isPcFlag="true" />
    <!-- 方案优势 -->
    <PlanAdvantage :list="planAdvantageList" :isPcFlag="true" />
    <!-- 典型案例 -->
    <TypicalCases :list="typicalCasesList" :isPcFlag="true" />
    <!-- 底部 -->
    <Footer type="pc" />
  </div>
</template>

<script>
import pageMixin from './mixins/pageMixin'
import dataList from './dataList'
export default {
  mixins: [pageMixin],
  components: {
    Header: () => import('@/components/header/index.vue'),
    Banner: () => import('@/components/Banner.vue'),
    UseDialog: () => import('@/components/UseDialog.vue'),
    Footer: () => import('@/components/footer/index.vue'),

    QrCodeDialog: () => import('./components/QrCodeDialog.vue'),
    ApplicableObjects: () => import('./components/ApplicableObjects.vue'),
    Solution: () => import('./components/Solution.vue'),
    PlanAdvantage: () => import('./components/PlanAdvantage.vue'),
    TypicalCases: () => import('./components/TypicalCases.vue'),
  },
  data() {
    return {
      pcBgImg: require('@/assets/images/landing-ofd/pcBannerBgImg.png'),
      applicableObjectsList: dataList.applicableObjectsList, // 适用对象数据
      solutionList: dataList.solutionList, // 解决方案数据
      planAdvantageList: dataList.planAdvantageList, // 方案优势数据
      typicalCasesList: dataList.typicalCasesList, // 典型案例数据
    }
  },
  mounted() {},
  methods: {
    // 留资弹框
    showDialog() {
      this.$refs.infoDialog.showDialog()
    },
    // 二维码弹框
    showQrCodeDialog() {
      this.$refs.qrcodeDialog.showQrCodeDialog()
    },
  },
}
</script>

<style lang="less">
.ofd-box-pc {
  padding-top: 60px;
}
* > img {
  max-width: 100%;
}

a {
  font-size: 1rem;
  color: #333;
}

a:hover,
input.error {
  color: #fa465a;
}

.container {
  width: 1200px\9;
}

@media (min-width: 1200px) {
  .main {
    min-width: 1200px;
  }
}

.banner,
.banner video,
.banner .text,
.banner .text .banner_tabbox .tab_listbox,
.con,
.con1,
.con1 .con1_tab .tab_box,
.con2,
.con2 .con2_tab .tab_box,
.con3,
.con4,
.con6,
.footer {
  min-width: 0;
}

.btn {
  display: inline-block;
  padding: 6px 12px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-image: none;
  border: 1px solid transparent;
  border-radius: 4px;
}
</style>
